<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>GHI CHÚ</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-textarea
            label="Ghi chú"
            v-model="content"
            outlined
            required
            :rules="[$rules.required]"
            class="required mb-2"
          ></v-textarea>
        </v-form>
        <div class="d-flex justify-center mb-6">
          <v-btn color="red " outlined dark @click="deleteNote">Xóa ghi chú</v-btn>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Cập nhật</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    state: Boolean,
    note: String,
    notes: Array,
    index: Number,
  },
  data() {
    return {
      dialog: false,
      content: '',
    }
  },

  watch: {
    state(state) {
      this.dialog = state
      if (state) {
        this.content = this.note
      }
    },
  },
  methods: {
    ...mapActions('studentTickets', ['updateStudentTicket']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true

        const updatedNotes = [...this.notes]
        updatedNotes[this.index] = this.content

        const data = {
          notes: updatedNotes,
        }
        const updated = await this.updateStudentTicket({ id: this.$route.params.id, ...data })
        if (updated) {
          this.$alert.success('Cập nhật ghi chú thành công!')
          this.$emit('refresh')
          this.close()
        } else {
          this.$alert.error('Cập nhật ghi chú thất bại')
          this.$loading.active = false
        }
      }
    },
    async deleteNote() {
      this.$loading.active = true

      const updatedNotes = this.notes.filter((_, i) => i !== this.index)

      const data = {
        notes: updatedNotes,
      }
      const updated = await this.updateStudentTicket({ id: this.$route.params.id, ...data })
      if (updated) {
        this.$alert.success('Xóa ghi chú thành công!')
        this.$emit('refresh')
        this.close()
      } else {
        this.$alert.error('Xóa ghi chú thất bại')
        this.$loading.active = false
      }
    },
  },
}
</script>
